import React, { ReactNode, useContext, useState } from 'react';
import { BsChevronRight, BsChevronDown } from 'react-icons/bs';
import './CollapsiblePanel.css';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    IconButton,
    Tooltip,
} from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { useNavigate } from 'react-router-dom';
import { useGetTermSetQuery } from '../../services/i18n/i18n.service';
import { PLATFORM_DEFS } from '../../constants/i18n/translations/termSetDefinitions/platform';
import { skipToken } from '@reduxjs/toolkit/query';
import SettingsContext from '../../contexts/settings.context';
import { SubscriberFormDefs } from '../../constants/i18n/translations/termDefinitions/platform';
import TranslatableText from '../i18n/TranslatableText';

interface CollapsiblePanelProps {
    collapsed: any;
    label: any;
    checked?: boolean;
    class: any;
    hasCheckbox: boolean;
    onCheckChange: (param: any) => void;
    value: any;
    children: ReactNode;
    defaultChecked: any;
    hasTooltip?: boolean;
}

const CollapsiblePanel = (props: CollapsiblePanelProps) => {
    const [isCollapsed, setIsCollapsed] = useState(!!props.collapsed);
    const navigate = useNavigate();
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onCheckChange) {
            const node = {
                label: props.label,
                value: props.value,
                checked: event.target.checked,
            };

            props.onCheckChange(node);
        }
    };
    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: PLATFORM_DEFS.SUBSCRIBER_FORM,
              }
            : skipToken
    );

    return (
        <>
            {isCollapsed && (
                <BsChevronRight
                    style={{ paddingRight: '10px' }}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    className="ic-w mx-1"
                />
            )}
            {!isCollapsed && (
                <BsChevronDown
                    style={{ paddingRight: '10px' }}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    className="ic-w mx-1"
                />
            )}
            {props.hasTooltip && props.value ? (
                <FormGroup style={{ display: 'inline-block' }}>
                    <FormControlLabel
                        label={props.label}
                        control={
                            <Tooltip
                                title={
                                    <TranslatableText
                                        termKey={
                                            SubscriberFormDefs.View_Business_Entity
                                        }
                                        termSet={termSet}
                                    />
                                }
                                placement="left-start">
                                <IconButton
                                    size="small"
                                    color="primary"
                                    ref={(ref) => {
                                        if (!ref) {
                                            return;
                                        }

                                        ref.onclick = (event) => {
                                            navigate(
                                                `/administration/organizations/business-entities/${props.value}`
                                            );
                                        };
                                    }}>
                                    <LaunchIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    />
                </FormGroup>
            ) : (
                <>
                    {props.hasCheckbox && props.value ? (
                        <FormGroup>
                            <FormControlLabel
                                label={props.label}
                                control={
                                    <Checkbox
                                        defaultChecked={props.checked}
                                        onChange={(event) => onChange(event)}
                                    />
                                }
                            />
                        </FormGroup>
                    ) : (
                        <label>{props.label}</label>
                    )}
                </>
            )}

            <div
                className={`${props.class} collapse-content ${
                    isCollapsed ? 'collapsed' : 'expanded'
                }`}>
                {props.children}
            </div>
        </>
    );
};

export default CollapsiblePanel;
